import { useHistory, useParams, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import Sidebar from "../../../myfin_v2/elements/Sidebar"
import Sidbarv2 from "../../Workspace-v2/Sidbarv2";
import  { ReactComponent as ActiveRadioBtn }  from '../../../myfin_v2/assets/icons/activeRadioBtn.svg'
import  { ReactComponent as InactiveRadioBtn }  from '../../../myfin_v2/assets/icons/inactiveRadioBtn.svg'
import  { ReactComponent as TickMark }  from '../../../myfin_v2/assets/icons/tickMark.svg'
import  { ReactComponent as Bar }  from '../../../myfin_v2/assets/icons/bluebarchart.svg'
import  { ReactComponent as List }  from '../../../myfin_v2/assets/icons/list.svg'
import  { ReactComponent as Table }  from '../../../myfin_v2/assets/icons/table.svg'
import  { ReactComponent as Pie }  from '../../../myfin_v2/assets/icons/pie.svg'
import  { ReactComponent as Default }  from '../../../myfin_v2/assets/icons/default.svg'
import  { ReactComponent as AddPlus }  from '../../../myfin_v2/assets/icons/AddPlus.svg'
import  { ReactComponent as SearchIcon }  from '../../../myfin_v2/assets/icons/SearchIcon.svg'
import  { ReactComponent as CloseIcon }  from '../../../myfin_v2/assets/icons/Close-green.svg'
import  { ReactComponent as ExpandIcon }  from '../../../myfin_v2/assets/icons/ExpandIcon.svg'
import  { ReactComponent as RightMark }  from '../../../myfin_v2/assets/icons/rightmark.svg'
import  { ReactComponent as RoundedCheck }  from '../../../myfin_v2/assets/icons/rounded_check.svg'
import  { ReactComponent as Filter }  from '../../../myfin_v2/assets/icons/overviewfilter.svg'
import  { ReactComponent as Downarrow }  from '../../../myfin_v2/assets/icons/overviewDwonarrow.svg'
import  { ReactComponent as EyeIcon }  from '../../../myfin_v2/assets/icons/eyeIcon.svg'
import workSpaceCss from "../../../myfin_v2/css/workSpaceOverView.module.css"
import { useState,useEffect } from 'react';
import { getBookClosureOverview, getBookClosureupdateOverviewFilters,getUpdateOverviewCards,getCopyWorkspaceViewToPrivate } from '../../../Bookclosure/Services/ApiHandler';

import { text } from 'cheerio';
import SuccessModal from "../../../myfin_v2/components/connections/SuccessModal";
import ErrorModal from "../../../myfin_v2/components/connections/ErrorModal";
import { components } from 'react-select';
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import OpenTask from '../../../myfin_v2/assets/imgs/overviewopen.png'
import InprogressTask from'../../../myfin_v2/assets/imgs/loanOverViewSecond1.png'
import CompletedTask from'../../../myfin_v2/assets/imgs/book-closure-completed.png'
import OverdueTask from'../../../myfin_v2/assets/imgs/overviewoverdue.jpg'
// import DraggableGrid from "../../Components/FSPreparetion/DraggableGrid";
import { DisplayCard } from "../../../myfin_v2/elements/DisplayCards";
import Profile from'../../../myfin_v2/assets/imgs/profile.jpg'


ChartJS.register(ArcElement, Tooltip, Legend);

const CustomDropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <Downarrow style={{ width: '16px', height: '16px' }} /> 
        </components.DropdownIndicator>
    );
};

const typeIcons = {
  bar: Bar,
  list: List,
  table: Table,
  pie: Pie
};
const OverViewNew = () => {

    const { workspaceId } = useParams();
    const location = useLocation();
    let a = location.pathname;
    let w_id = a.split("/");

    const routerHistory  = useHistory();

    const [companyList, setcompanyList] = useState();
    const [taskStatusSummary, setTaskStatusSummary] = useState({});
    const [moduleProgress, setModuleProgress] = useState({}); 
    const [filtersData, setfiltersData] = useState({}); 
    const [showFilter, setShowFilter] = useState(true);
    const [overViewConfigs, setoverViewConfigs]= useState({});

    const [moduleCompanyList, setModuleCompanyList] = useState([]);
    const [overdueTasksData, setoverdueTasksData] = useState([]);
    const [upcomingDeadlinesData, setupcomingDeadlinesData] = useState([]);
    const [moduleCompanySummary, setModuleCompanySummary] = useState({});
    const [userName, setUserName] = useState("");
    const [currentFilters,setCurrentFilters] = useState([]);
    const [commentsData, setcommentsData] = useState([]);
    const [assigneeProgressData, setassigneeProgressData] = useState([]);
    const [approvalPendingData, setapprovalPendingData] = useState([]);
    const [tasksAssignedToUserData, setTasksAssignedToUserData] = useState([]);
    const [manageCardsList, setManageCardsList] = useState([]);
    const [showManageCards, setShowManageCards] = useState(false); 
    const [selectedView, setSelectedView] = useState("workspace"); 

    const [showBuildFromScratch, setShowBuildFromScratch] = useState(false);
    const [privateLibraryCards, setPrivateLibraryCards] = useState([]);
    const [selectedPrivateCards, setSelectedPrivateCards] = useState([]);
    const [workspaceCardIDs, setWorkspaceCardIDs] = useState([]);
    const [privateCardIDs, setPrivateCardIDs] = useState([]);

    // const [editMode, setEditMode] = useState(false);
    // const [gridLayouts, setGridLayouts] = useState({});

    const fetchOverview = async (arg) => {

        const { company, user, role, module } = arg || {};
    
        const filters = {
           
            ...(Array.isArray(company) && company.length > 0
            ? { companyID: company.map(c => c.value) } 
            : company?.value

            ? { companyID: [company.value] } 
            : {}),
            ...(Array.isArray(user) && user.length > 0
            ? { userID: user.map(u => u.value) } 
            : user?.value
            ? { userID: [user.value] }
            : {}),
            ...(Array.isArray(role) && role.length > 0
            ? { role: role.map(r => r.value) } 
            : role?.value
            ? { role: [role.value] } 
            : {}),
          ...(Array.isArray(module) && module.length > 0
            ? { module: module.map(m => m.value) } 
            : module?.value
            ? { module: [module.value] } 
            : {}),
        };


        const data = {
            workspaceID: workspaceId,
            view:selectedView,
                ...(Object.keys(filters).length > 0 && { filters }),
        }



            
        try {
            const response = await getBookClosureOverview(data);
            
            setModuleProgress(response.data?.moduleProgress || {});
            setTaskStatusSummary(response.data?.taskStatusSummary || {});
            setfiltersData(response.data?.filtersData || {});
            setModuleCompanySummary(response.data?.moduleCompanySummary || {});
            setModuleCompanyList(response.data?.moduleCompaniesList || []);
            setoverdueTasksData(response.data?.overdueTasks || []);
            setupcomingDeadlinesData(response.data?.upcomingDeadlines || []);
            setoverViewConfigs(response.data?.overviewConfigs || {});
            setUserName(response.data?.loggedUser || "")
            setcommentsData(response.data?.commentStatistics || []);
            setassigneeProgressData(response.data?.assigneeProgress || {});
            setapprovalPendingData(response.data?.approvalPending || []);
            setTasksAssignedToUserData(response.data?.tasksAssignedToUser || []);
            setManageCardsList(response.data?.bookClosureOverviewLibraries || []);

            

            
            if(!arg){
                setCurrentFilters(response.data?.overviewConfigs?.filters || [])
            }else if (arg){
                setCurrentFilters(filters || [])
            }


        
        } catch (error) {
            console.error('Error fetching overview:', error);
        }
    
    };
          
   


    const handleAddCard = async (cardId) => {
    let updatedIDs = [...workspaceCardIDs];
    if (!updatedIDs.includes(cardId)) updatedIDs.push(cardId);
    else updatedIDs = updatedIDs.filter(id => id !== cardId);

    setWorkspaceCardIDs(updatedIDs);
    setManageCardsList(prev =>
        prev.map(card =>
            updatedIDs.includes(card._id)
                ? { ...card, check: true }
                : { ...card, check: false }
        )
    );

    const payload = {
        workspaceID: workspaceId,
        overviewModule: "bookclosure",
        view: selectedView,
        libraryIDs: updatedIDs,
    };


    try {
        const response = await getUpdateOverviewCards(payload);  
        console.log("getUpdateOverviewCards response:", response);

        if (response?.data) {
            console.log("response.data:", response.data);
            console.log("Updated libraryIDs returned by API:", response.data?.libraryIDs);
        }
    } catch (error) {
        console.error("Error updating workspace cards:", error);
    }
};






    const handleAddSelectedPrivateCards = async (cardIds = null) => {
    let updatedIDs;

    if (cardIds) {
        const ids = (Array.isArray(cardIds) ? cardIds : [cardIds])
            .filter(id => typeof id === "string"); 

        updatedIDs = [...privateCardIDs];

        ids.forEach(id => {
            if (!updatedIDs.includes(id)) {
                updatedIDs.push(id);
            } else {
                updatedIDs = updatedIDs.filter(i => i !== id);
            }
        });


        setSelectedPrivateCards(prev =>
            prev.concat(ids.filter(id => !prev.includes(id)))
        );
    } else {
        updatedIDs = [...new Set([...privateCardIDs, ...selectedPrivateCards])];
    }


    const payload = {
        workspaceID: workspaceId,
        overviewModule: "bookclosure",
        view: selectedView,
        libraryIDs: updatedIDs,
    };


    try {
        await getUpdateOverviewCards(payload);

        setPrivateCardIDs(updatedIDs);

        setManageCardsList(prev =>
            prev.map(card =>
                updatedIDs.includes(card._id)
                    ? { ...card, check: true }
                    : { ...card, check: false }
            )
        );

        if (!cardIds) setShowBuildFromScratch(false);

        fetchOverview({ view: "private" })
            .then(res => {
                console.log("fetchOverview response:", res);
            })
            .catch(err => {
                console.error("fetchOverview error:", err);
            });
    } catch (error) {
        console.error("Error updating private cards:", error);
    }
};






    const handlePrivateCardSelect = (cardId) => {
        setSelectedPrivateCards(prev =>
            prev.includes(cardId)
                ? prev.filter(id => id !== cardId)
                : [...prev, cardId]
        );
    };



    const fetchPrivateLibraryCards = async () => {
        try {
            const response = await getBookClosureOverview({ workspaceID: workspaceId, view: "workspace" });
            const privateCards = response.data?.bookClosureOverviewLibraries || [];
            setPrivateLibraryCards(privateCards);
            setShowBuildFromScratch(true);
        } catch (error) {
            console.error("Error fetching private library cards:", error);
        }
    };



  const handleCopyFromWorkspace = async () => {
      try {
          const payload = {
             workspaceID: workspaceId,
             overviewModule: "bookclosure"

           };  
          const response = await getCopyWorkspaceViewToPrivate(payload);

          setSelectedView("private");
          await fetchOverview({ view: "private" });

      } catch (error) {
          console.error("Error copying workspace view:", error);
      }
  };


    useEffect(() => {
        fetchOverview();
    }, [selectedView])

 
    
    const visibleCards = manageCardsList
    .filter(item => item.check === true && (selectedView === "workspace" ? item.view === "workspace" : item.view === "workspace" || item.view === "private"))
    .map(item => item.keyword);

    



    const hidePrivateUI = selectedView === "private" && visibleCards.length === 0;

    useEffect(() => {
      
    if (selectedView === "private") {
      const checkedIDs = manageCardsList
        .filter(card => card.check)
        .map(card => card._id);
        
      setPrivateCardIDs(checkedIDs);
    } else if (selectedView === "workspace"){
      const checkedIDs = manageCardsList
        .filter(card => card.check)
        .map(card => card._id);
        setWorkspaceCardIDs(checkedIDs);
    }
  }, [manageCardsList, selectedView]);


    return(
        <div className={`${workSpaceCss.df} ${workSpaceCss.overFlowHidden}`}>
            <div className={`${workSpaceCss.df}`} style={{ width: "max-content" }}>
                <Sidebar />
                <Sidbarv2 w_id={w_id} />
            </div>

            <div className={`${workSpaceCss.w100per} ${workSpaceCss.mainContainerBg} ${workSpaceCss.OverviewContainer}`}>
                <div className={`${workSpaceCss.OverViewTopSection}`}>
                    <OverViewHeader 
                    userName={userName}
                    selectedView={selectedView} 
                    setSelectedView={setSelectedView}
                    setShowManageCards={setShowManageCards}
                    hidePrivateUI={hidePrivateUI} 
                    // editMode={editMode}         // Pass editMode
                    // setEditMode={setEditMode}   // Pass setter
                   />
                    <ModuleSelection 
                    showFilter={showFilter} 
                    setShowFilter={setShowFilter} 
                    selectedView={selectedView} 
                    hidePrivateUI={hidePrivateUI} 
                    />
                    {!hidePrivateUI && (

                    <Filterlayer
                        filtersData={filtersData}
                        workspaceId={workspaceId}
                        fetchOverview={fetchOverview}
                        overViewConfigs={overViewConfigs}
                        showFilter={showFilter}
                        setShowFilter={setShowFilter}  

                    />
                    )}
                </div>
                <div  className={`${workSpaceCss.cardsContainerOverviewSection}`}>

                    {showBuildFromScratch && selectedView === "private" ? (
                    <div>
                        {/* Header row */}
                        <div className={workSpaceCss.headerRow}>
                        <div>
                            <h3 className={workSpaceCss.buildTitle}>Select cards to build your view</h3>
                            <p className={workSpaceCss.buildSubtitle}>You can add or remove selected cards later too</p>
                        </div>
                        <div className={workSpaceCss.actionButtons}>
                            <button className={workSpaceCss.outlineBtncancel} onClick={() => setShowBuildFromScratch(false)}>Cancel</button>
                            <button className={workSpaceCss.primaryBtn}  onClick={() => handleAddSelectedPrivateCards(null)}><RightMark/>Add selected cards</button>
                        </div>
                        </div>

                        {/* Cards grid */}
                        <div className={workSpaceCss.grid4}>
                        {privateLibraryCards.map(card => (
                            <div
                            key={card._id}
                            className={`${workSpaceCss.cardItem} ${selectedPrivateCards.includes(card._id) ? workSpaceCss.selectedCard : ""}`}
                            onClick={() => handlePrivateCardSelect(card._id)}
                            >
                            <div className={workSpaceCss.cardTopRow}>
                                <div className={workSpaceCss.cardIcon}>
                                 {(() => {
                                    const cardType = card.type?.toLowerCase();      
                                    const Icon = typeIcons[cardType] || Default;    
                                    return <Icon width={59.45} height={59.45}/>;
                                  })()}

                                {selectedPrivateCards.includes(card._id) && (
                                    <div className={workSpaceCss.tickMark}>
                                    <RoundedCheck />
                                    </div>
                                )}
                                </div>
                            </div>
                            <div className={workSpaceCss.cardText}>
                                <div className={workSpaceCss.cardTitle}>{card.title}</div>
                                <div className={workSpaceCss.cardDescription}>{card.description}</div>
                            </div>
                            </div>
                        ))}
                        </div>



                        
                    </div>
                    ) : hidePrivateUI ? (

                    <div className={workSpaceCss.welcomeScreen}>
                        <div className={workSpaceCss.welcomeScreenH}>Welcome to Private view</div>
                        <div className={workSpaceCss.welcomeScreenP}>
                         <strong>Private view is private to you and no one else can view it</strong>. 
                        You can either build this view from scratch by selecting cards or else make 
                        a copy from the workspace and edit on it.
                        </div>

                    <div className={workSpaceCss.buttonLayout}>
                        <button className={workSpaceCss.outlineBtn}onClick={fetchPrivateLibraryCards}>Build from scratch</button>
                        <span className={workSpaceCss.orText}>OR</span>
                        <button className={workSpaceCss.outlineBtn}onClick={handleCopyFromWorkspace}>Make a copy from workspace</button>
                        </div>
                    </div>
                    ) : (
                    <>
                    <TasksLayer 
                        taskStatusSummary={taskStatusSummary} 
                        visibleCards={visibleCards}  

                    />
                    <CardsContainer 
                        moduleProgress={moduleProgress} 
                        overdueTasksData={overdueTasksData}
                        visibleCards={visibleCards}  
                        routerHistory={routerHistory}
                        w_id={w_id}
                    />
              
                    <UpcomingDeadlinesCardsContainer 
                        tasksAssignedToUserData={tasksAssignedToUserData} 
                        upcomingDeadlinesData={upcomingDeadlinesData}
                        visibleCards={visibleCards}  
                        routerHistory={routerHistory}
                        w_id={w_id}
                    />
                    <AssigneeContainer
                        assigneeProgressData={assigneeProgressData}
                        visibleCards={visibleCards}  


                    />
                    <PendingDataContainer
                        approvalPendingData={approvalPendingData}
                        commentsData={commentsData}
                        visibleCards={visibleCards}  
                        routerHistory={routerHistory}
                        w_id={w_id}

                    />
                    <StatusByCompany 
                        moduleCompanySummary={moduleCompanySummary} 
                        moduleCompanyList={moduleCompanyList}
                        w_id={w_id}
                        routerHistory={routerHistory}
                        currentFilters={currentFilters}
                        visibleCards={visibleCards}  

                    />
                    <ManageCardsDrawer
                    show={showManageCards}
                    onClose={() => setShowManageCards(false)}
                    manageCardsList={manageCardsList}
                    handleAddCard={handleAddCard}
                    handleAddSelectedPrivateCards={handleAddSelectedPrivateCards}  
                    selectedView={selectedView} 
                    workspaceId={workspaceId}
                    />
                     {/* <DraggableGrid 
                      cards={visibleCards}            // Only show cards user selected
                      editMode={editMode}            // Enable drag/resize only when toggle is on
                      layouts={gridLayouts}
                      onLayoutChange={(newLayout, allLayouts) => setGridLayouts(allLayouts)}
                      w_id={w_id}
                      routerHistory={routerHistory}
                  /> */}

                </>
                )}

                </div>
                
            </div>
        </div>
    )
}

export default OverViewNew;

const OverViewHeader = ({userName = "",selectedView, setSelectedView,setShowManageCards,hidePrivateUI    }) => {
     


    return (
        <div className={`${workSpaceCss.df} ${workSpaceCss.w100per} ${workSpaceCss.jsBtw} ${workSpaceCss.alignCenter}`}>
            <div>
                <div className={`${workSpaceCss.userName}`}>
                    Hello{userName ? `, ${userName}` : ""}!
                </div>
            </div>
            <div>
               
                <div className={`${workSpaceCss.df}`}>
                <button
                    className={`${workSpaceCss.custom_btn} ${
                    selectedView === "workspace" ? workSpaceCss.primary : workSpaceCss.secondary
                    }`}
                    style={{ borderRadius: "8.18px 0px 0px 8.18px" }}
                    onClick={() => setSelectedView("workspace")}
                >
                    Workspace View
                </button>

                <button
                    className={`${workSpaceCss.custom_btn} ${
                    selectedView === "private" ? workSpaceCss.primary : workSpaceCss.secondary
                    }`}
                    style={{ borderRadius: "0 8.18px 8.18px 0" }}
                    onClick={() => setSelectedView("private")}
                >
                    Private View
                </button>
                </div>


            </div>
            {!hidePrivateUI  ? (
            <div className={`${workSpaceCss.df}`}>
                <div className={`${workSpaceCss.df} ${workSpaceCss.alignCenter}`}>
                    <div>
                        <span className="module-toggles">
                            <div className="toggle-item">
                                <div className="toggle-container">
                                    <label className="switch">
                                        <input
                                            type="checkbox"
                                            checked={false}
                                            onChange={() => {}}
                                            // checked={editMode}          // Controlled by state
                                            // onChange={() => setEditMode(!editMode)}  // Toggle  
                                        />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </span>
                    </div>
                    
                    <div className={`${workSpaceCss.p10} ${workSpaceCss.primaryTxt} ${workSpaceCss.txtSize1rm}`}>
                        Edit Mode
                    </div>
                </div>
                
                <button type="button"
                className={`${workSpaceCss.alignContentCenter} ${workSpaceCss.manageCards} ${workSpaceCss.bR10} ${workSpaceCss.ml15} ${workSpaceCss.fw500}`}
                onClick={() => setShowManageCards(true)}

                >
                Manage Cards
                </button>
            </div>
            ) : (
            <div style={{ width: "289px" }} />

            )}
        </div>
    )
}




const ManageCardsDrawer = ({ show, onClose, manageCardsList, handleAddCard,handleAddSelectedPrivateCards, selectedView }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [showSearch, setShowSearch] = useState(false); 


  if (!show) return null;


const filteredCards = manageCardsList
  .filter(card => selectedView === "private" || card.view === selectedView)
  .filter(card => card.title.toLowerCase().includes(searchValue.toLowerCase()));


  return (
    <div className={`${workSpaceCss.drawerOverlay} ${isFullScreen ? workSpaceCss.fullScreen : ""}`}>
      <div className={`${workSpaceCss.drawer} ${isFullScreen ? workSpaceCss.drawerFull : ""}`}>
        <div className={workSpaceCss.drawerHeader}>
          <h3 className={workSpaceCss.drawerTitle}>Manage Cards</h3>

          <div className={workSpaceCss.headerActions}>
            
            {/* Search toggle */}
            {!showSearch ? (
              <button 
                type="button" 
                className={workSpaceCss.iconBtn} 
                onClick={() => setShowSearch(true)}
              >
                <SearchIcon />
              </button>
            ) : (
              <div className={workSpaceCss.searchBox}>
                <button 
                  type="button" 
                  className={workSpaceCss.iconBtn} 
                  onClick={() => setShowSearch(false)}  
                >
                  <SearchIcon />
                </button>
                <input
                  type="search"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  placeholder="Type something..."
                  className={workSpaceCss.searchInput}
                  autoFocus
                />
                {searchValue && (
                  <button
                    type="button"
                    className={workSpaceCss.clearBtn}
                    onClick={() => setSearchValue("")}
                  >
                    <CloseIcon />
                  </button>
                )}
              </div>
            )}

            <button className={workSpaceCss.iconBtn} onClick={() => setIsFullScreen(!isFullScreen)}>
              <ExpandIcon />
            </button>
            <button className={workSpaceCss.iconBtn} onClick={onClose}>
              <CloseIcon />
            </button>
          </div>
        </div>

        <div className={`${workSpaceCss.drawerContent} ${isFullScreen ? workSpaceCss.grid5 : workSpaceCss.grid2}`}>
          {filteredCards.length > 0 ? (
            filteredCards.map((card) => (
                <div
                key={card._id}
                className={`${workSpaceCss.cardItem} ${card.check ? workSpaceCss.selectedCard : ""}`}
                >

                <div className={workSpaceCss.cardTopRow}>
                  <div className={workSpaceCss.cardIcon}>

                      {(() => {
                      const cardType = card.type?.toLowerCase();      
                      const Icon = typeIcons[cardType] || Default;    
                      return <Icon width={59.45} height={59.45}/>;
                    })()}

                  </div>
                 

                    <button
                        className={card.check ? workSpaceCss.addedButton : workSpaceCss.addButton}
                        onClick={() => {
                            if (selectedView === "private") {
                            handleAddSelectedPrivateCards(card._id); 
                            } else {
                                handleAddCard(card._id);
                            }
                        }}
                    >
                      {card.check ? (
                            <>
                                <RightMark /> Added
                            </>
                        ) : (
                            <>
                                <AddPlus /> Add to overview
                            </>
                        )}
                    </button>


                </div>
                <div className={workSpaceCss.cardText}>
                  <div className={workSpaceCss.cardTitle}>{card.title}</div>
                  <div className={workSpaceCss.cardDescription}>{card.description}</div>
                </div>
              </div>
            ))
          ) : (
            <p>No cards available.</p>
          )}
        </div>
      </div>
    </div>
  );
};



const ModuleSelection = ({ showFilter, setShowFilter,selectedView, hidePrivateUI  }) => {

    return(
        <div className={`${workSpaceCss.layerTwoSpacing} ${workSpaceCss.df} ${workSpaceCss.jsBtw}`}>
            <div>
                <button className={`${workSpaceCss.txtSize1_1rm} ${workSpaceCss.bR10} ${workSpaceCss.fw400} ${workSpaceCss.mr10} ${workSpaceCss.moduleActiveBtn}`} type="button">Book Closure</button>
                <button className={`${workSpaceCss.txtSize1_1rm} ${workSpaceCss.bR10} ${workSpaceCss.fw400} ${workSpaceCss.mr10} ${workSpaceCss.moduleInActiveBtn}`} type="button">Standalone</button>
                <button className={`${workSpaceCss.txtSize1_1rm} ${workSpaceCss.bR10} ${workSpaceCss.fw400} ${workSpaceCss.mr10} ${workSpaceCss.moduleInActiveBtn}`} type="button">Consolidation</button>
                <button className={`${workSpaceCss.txtSize1_1rm} ${workSpaceCss.bR10} ${workSpaceCss.fw400} ${workSpaceCss.mr10} ${workSpaceCss.moduleInActiveBtn}`} type="button">MIS</button>
            </div>
            {!hidePrivateUI && !showFilter && (


            <div  className={workSpaceCss.eyeIconWrapper}>
            
                <button
                    className={`${workSpaceCss.bR10} ${workSpaceCss.fw400} ${workSpaceCss.filterBtns}`}
                    type="button"
                    onClick={() => setShowFilter(prev => !prev)}
                    
                >
                    {/* {showFilter ? 'Hide Filter' : 'Show Filter'} */}
                    <EyeIcon/>
                </button>
                <span className={workSpaceCss.eyeTooltipText_unique123}>Show Filters</span>

            </div>
            )}
        </div>
    )
}

const CustomOption = (props) => {
  const isSelected = props.isSelected;

  return (
    <components.Option {...props}>
      <div
        style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: isSelected ? "#f1f9f4" : "transparent",
            borderRadius: "8px",
            fontWeight: "500",
            color: "#1A4338",
            userSelect: "none",
            padding: "10px 12px",
            marginBottom:"5px"
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = isSelected ? "#f1f9f4" : "transparent";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = isSelected ? "#f1f9f4" : "transparent";
        }}
      >
        <span>{props.label}</span>
        {isSelected && (
       
        <TickMark width={18} height={18} />

        )}
      </div>
    </components.Option>
  );
};

const CustomValueContainer = ({ children, ...props }) => {
  const selectedOptions = props.getValue();

  return (
    <components.ValueContainer {...props}>
      {selectedOptions.length > 0 ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'nowrap',
            padding: '4px 8px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '100%',
          }}
        >
          <div style={{ flexGrow: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {selectedOptions.map((opt) => opt.label).join(', ')}
          </div>
          {children[1]}
        </div>
      ) : (
        children
      )}
    </components.ValueContainer>
  );
};

const CustomMenuList = (props) => {
  const { options, selectProps, children, onConfirm } = props;
  const selectedOptions = selectProps.value || [];
  const allSelected = selectedOptions.length === options.length;

  const toggleSelectAll = () => {
    if (allSelected) {
      selectProps.onChange([]);
    } else {
      selectProps.onChange(options);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <components.MenuList {...props}>
        {/* Fixed Top: Select All */}
        <div
          style={{
            position: "sticky",
            top: "-4px",
            zIndex: 1,
            backgroundColor: "white",
            padding: "5px 0px",
            borderBottom: "1px solid #c2e6d1",
            cursor: "pointer",
          }}
          onClick={toggleSelectAll}
        >
          <label style={{ display: "flex", alignItems: "center", margin: 0, cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={allSelected}
              readOnly
              style={{ marginRight: "8px", pointerEvents: "none" }}
            />
            <span style={{ fontWeight: 500, color: "#1A4338" }}>
              {allSelected ? "Unselect All" : "Select All"}
            </span>
          </label>
        </div>

        {/* Scrollable Options */}
        <div style={{ maxHeight: "500px", overflowY: "auto", paddingBottom: "60px",marginTop:"3px" }}>
          {children}
        </div>

        {/* Fixed Bottom: Confirm */}
        <div
          style={{
            position: "sticky",
            bottom: "-4px",
            padding: "8px 12px",
            borderTop: "1px solid #c2e6d1",
            backgroundColor: "white",
          }}
        >
          <button
            style={{
              width: "100%",
              backgroundColor: "#205a46",
              color: "white",
              padding: "8px 16px",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 500,
            }}
            onClick={(e) => {
              e.stopPropagation();
              onConfirm();        
            }}
          >
            Confirm
          </button>
        </div>
      </components.MenuList>
    </div>
  );
};

const Filterlayer = ({filtersData={},workspaceId,fetchOverview,overViewConfigs ,showFilter,setShowFilter}) => {

    const [selectedCompany, setSelectedCompany] = useState([]);
    const [selectedUser, setSelectedUser] = useState([]);
    const [selectedRole, setSelectedRole] = useState([]);
    const [selectedModule, setSelectedModule] = useState([]);
    const [isSaving, setIsSaving] = useState(false); 
    const [showSuccessToaster, setShowSuccessToaster] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const [showErrorToaster, setShowErrorToaster] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isCompanyMenuOpen, setIsCompanyMenuOpen] = useState(false);
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
    const [isRoleMenuOpen, setIsRoleMenuOpen] = useState(false);
    const [isModuleMenuOpen, setIsModuleMenuOpen] = useState(false);
    const [hasApplied, setHasApplied] = useState(false); 

    const companies = filtersData?.companies
    ?.map(company => ({
        value: company._id,
        label: company.company_name
    }))
    ?.sort((a, b) => a.label.localeCompare(b.label));

    const users = filtersData?.users
    ?.map(user => ({
        label: user.name || 'Unknown',
        value: user._id
    }))
    ?.sort((a, b) => a.label.localeCompare(b.label));

    const modulesList = [...new Set(filtersData?.modules?.map(module => module.modules).flat())]
        .map(module => ({ value: module, label: module }))
        .sort((a, b) => a.label.localeCompare(b.label));

    const roleList = [
        { value: "approver", label: "Approver" },
        { value: "assignee", label: "Assignee" }
    ].sort((a, b) => a.label.localeCompare(b.label));


   
    useEffect(() => {
        if (hasApplied) return;
        if (!filtersData || !overViewConfigs) return;

        const filterObj = overViewConfigs?.filters?.[0] || {};

        const companyIDs = filterObj?.companyID || [];
        const roleListFromConfig = filterObj?.role || [];
        const moduleListFromConfig = filterObj?.module || [];
        const userIDs = filterObj?.userID || [];

        const matchedCompanies = companies?.filter(c => companyIDs.includes(c.value)) || [];
        const matchedUsers = users?.filter(u => userIDs.includes(u.value)) || [];
        const matchedRoles = roleList?.filter(r => roleListFromConfig.includes(r.value)) || [];
        const matchedModules = modulesList?.filter(m => moduleListFromConfig.includes(m.value)) || [];

        setSelectedCompany(matchedCompanies);
        setSelectedUser(matchedUsers);
        setSelectedRole(matchedRoles);
        setSelectedModule(matchedModules);

    }, [filtersData, overViewConfigs]);

    const showToaster = (message, type) => {
        if (type === "success") {
            setSuccessMessage(message);
            setShowSuccessToaster(true);
            setTimeout(() => {
                setShowSuccessToaster(false);
                setSuccessMessage("");
            }, 3000); // Hide after 3 seconds
        } else if (type === "error") {
            setErrorMessage(message);
            setShowErrorToaster(true);
            setTimeout(() => {
                setShowErrorToaster(false);
                setErrorMessage("");
            }, 3000); // Hide after 3 seconds
        }
    };

    // --- CLOSE HANDLERS FOR EACH MODAL ---
    const handleCloseSuccessToaster = () => {
        setShowSuccessToaster(false);
        setSuccessMessage("");
    };

    const handleCloseErrorToaster = () => {
        setShowErrorToaster(false);
        setErrorMessage("");
    };


    
    const handleSaveFilter = async () => {
        const filters = {};

        if (Array.isArray(selectedCompany) && selectedCompany.length > 0) {
            filters.companyID = selectedCompany.map(c => c.value);
        }

        if (Array.isArray(selectedUser) && selectedUser.length > 0) {
            filters.userID = selectedUser.map(u => u.value);
        }

        if (Array.isArray(selectedRole) && selectedRole.length > 0) {
            filters.role = selectedRole.map(r => r.value.toLowerCase()); // or r.label
        }

        if (Array.isArray(selectedModule) && selectedModule.length > 0) {
            filters.module = selectedModule.map(m => m.value);
        }

        const payload = {
            workspaceID: workspaceId,
            overviewModule: "bookclosure",
            view: "workspace",
            filters
        };


        try {
            setIsSaving(true);
            const response = await getBookClosureupdateOverviewFilters(payload);
            showToaster("Filter saved successfully!", "success");
        } catch (error) {
            console.error("Error saving filter:", error);
            showToaster("Failed to save filter. Please try again.", "error");
        } finally {
            setIsSaving(false);
        }
    };


    const handleApplyFilters = () => {
        setHasApplied(true);
        fetchOverview({
            company: selectedCompany?.length ? selectedCompany : null,
            user: selectedUser?.length ? selectedUser : null,
            role: selectedRole?.length ? selectedRole : null,
            module: selectedModule?.length ? selectedModule : null,
        });
    };

    return(
        <div className={`${workSpaceCss.df} ${workSpaceCss.alignCenter}`}style={{ display: showFilter ? 'flex' : 'none' }}>
            <div className={workSpaceCss.mr10}>
                <Filter/>
            </div>
            
            <Select 
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            menuIsOpen={isCompanyMenuOpen} 
            onMenuOpen={() => setIsCompanyMenuOpen(true)}
            onMenuClose={() => setIsCompanyMenuOpen(false)}
            components={{ 
                IndicatorSeparator: () => null,
                Option: CustomOption,             
                MenuList: (props) => (
                <CustomMenuList
                    {...props}
                    onConfirm={() => {
                        const selected = props.getValue(); 
                        setSelectedCompany(selected);     
                        setIsCompanyMenuOpen(false);      
                        console.log("Confirmed companies:", selected.map(c => c.value));
                    }}
                />
                ),
                ValueContainer: CustomValueContainer,
                MultiValueRemove: () => null,
                ClearIndicator: () => null,
                DropdownIndicator: CustomDropdownIndicator, 

            }}
            onChange={(selectedCompanies) => {
                setSelectedCompany(selectedCompanies || []);
            }}
            value={selectedCompany}
            options={companies}
            placeholder="Select company"
            name="companies"
            className={`w-100 mt-0 ${workSpaceCss.custSelect} ${workSpaceCss.mr10}`}
            classNamePrefix="select"
            styles={{
                ...customStyles,
                 control: (provided,state) => ({
                    ...provided,
                    backgroundColor: '#F4FAF5', 
                    borderColor: '#A0DABC',       
                    borderWidth: '1px',           
                    borderStyle: 'solid',         
                    borderRadius:'10px',
                    boxShadow: state.isFocused ? '0 0 0 0px #A0DABC' : 'none', 
                    '&:hover': {
                        borderColor: '#A0DABC',   
                    },
                }),
                option: (provided, state) => ({
                    ...provided,
                    backgroundColor: 'transparent',
                    padding:'0px',
                    borderColor: 'transparent',
                    cursor:'pointer',
                    '&:hover': {
                        backgroundColor: 'transparent',
                    }
                }),
               
             placeholder: (provided) => ({
                ...provided,
                color: '#809790',
                fontSize:'14px',
                fontWeight:'400'              
            }),    
            }}
            isClearable={true}
            isSearchable={false}
            />

           
            <Select  
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                menuIsOpen={isUserMenuOpen} 
                onMenuOpen={() => setIsUserMenuOpen(true)}
                onMenuClose={() => setIsUserMenuOpen(false)}
                components={{ 
                    IndicatorSeparator: () => null,
                    Option: CustomOption,             
                    MenuList: (props) => (
                    <CustomMenuList
                        {...props}
                        onConfirm={() => {
                        const selected = props.getValue(); 
                        setSelectedUser(selected);     
                        setIsUserMenuOpen(false);     
                        console.log("Confirmed Users:", selected.map(c => c.value));
                        }}
                    />
                    ),
                    ValueContainer: CustomValueContainer,
                    MultiValueRemove: () => null,
                    ClearIndicator: () => null,
                    DropdownIndicator: CustomDropdownIndicator, 

                }}
                onChange={(selectedUser) => {
                    setSelectedUser(selectedUser || []);
                }}
                value={selectedUser}                
                options={users}
                placeholder="Select user"
                name="status"
                className={`w-100 mt-0 ${workSpaceCss.custSelect} ${workSpaceCss.mr10}`}
                classNamePrefix="select"
                styles={{
                    ...customStyles,
                     control: (provided,state) => ({
                    ...provided,
                    backgroundColor: '#F4FAF5', 
                    borderColor: '#A0DABC',       
                    borderWidth: '1px',           
                    borderStyle: 'solid',         
                    borderRadius:'10px',
                    boxShadow: state.isFocused ? '0 0 0 1px #A0DABC' : 'none', 
                    '&:hover': {
                        borderColor: '#A0DABC',   
                    },
                    }),
                    option: (provided, state) => ({
                        ...provided,
                        backgroundColor: 'transparent',
                        padding:'0px',
                        borderColor: 'transparent',
                        cursor:'pointer',
                        '&:hover': {
                            backgroundColor: 'transparent',
                        }
                    }),
                    placeholder: (provided) => ({
                        ...provided,
                        color: '#809790',
                        fontSize:'14px',
                        fontWeight:'400'              
                    }),   
                }}
                isClearable={true}
                isSearchable={false}
            />
            <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            menuIsOpen={isRoleMenuOpen} 
            onMenuOpen={() => setIsRoleMenuOpen(true)}
            onMenuClose={() => setIsRoleMenuOpen(false)}
            components={{ 
                IndicatorSeparator: () => null,
                Option: CustomOption,             
                MenuList: (props) => (
                <CustomMenuList
                    {...props}
                    onConfirm={() => {
                    const selected = props.getValue(); 
                    setSelectedRole(selected);     
                    setIsRoleMenuOpen(false);     
                    console.log("Confirmed Roles:", selected.map(c => c.value));
                    }}
                />
                ),
                ValueContainer: CustomValueContainer,
                MultiValueRemove: () => null,
                ClearIndicator: () => null,
                DropdownIndicator: CustomDropdownIndicator, 

            }}
            onChange={(selectedRole) => {
                setSelectedRole(selectedRole || []);
            }}
                value={selectedRole}                
                options={roleList}
                placeholder="Select role"
                name="status"
                className={`w-100 mt-0 ${workSpaceCss.custSelect} ${workSpaceCss.mr10}`}
                classNamePrefix="select"
                styles={{
                    ...customStyles,
                     control: (provided,state) => ({
                    ...provided,
                    backgroundColor: '#F4FAF5', 
                    borderColor: '#A0DABC',       
                    borderWidth: '1px',           
                    borderStyle: 'solid',         
                    borderRadius:'10px',
                    boxShadow: state.isFocused ? '0 0 0 1px #A0DABC' : 'none', 
                    '&:hover': {
                        borderColor: '#A0DABC',   
                    },
                  }),
                    option: (provided, state) => ({
                        ...provided,
                        backgroundColor: 'transparent',
                        padding:'0px',
                        borderColor: 'transparent',
                        cursor:'pointer',
                        '&:hover': {
                            backgroundColor: 'transparent',
                        }
                    }),
                    placeholder: (provided) => ({
                        ...provided,
                        color: '#809790',
                        fontSize:'14px',
                        fontWeight:'400'              
                    }),   
                }}
                isClearable={true}
                isSearchable={false}
            />
           
            <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            menuIsOpen={isModuleMenuOpen} 
            onMenuOpen={() => setIsModuleMenuOpen(true)}
            onMenuClose={() => setIsModuleMenuOpen(false)}
            components={{ 
                IndicatorSeparator: () => null,
                Option: CustomOption,             
                MenuList: (props) => (
                <CustomMenuList
                    {...props}
                    onConfirm={() => {
                    const selected = props.getValue(); 
                    setSelectedModule(selected);     
                    setIsModuleMenuOpen(false);      
                    console.log("Confirmed Modules:", selected.map(c => c.value));
                    }}
                />
                ),
                ValueContainer: CustomValueContainer,
                MultiValueRemove: () => null,
                ClearIndicator: () => null,
                DropdownIndicator: CustomDropdownIndicator, 

            }}
            onChange={(selectedModule) => {
                setSelectedModule(selectedModule || []);
            }}
            value={selectedModule}
            options={modulesList}
            placeholder="Select modules"
            name="modules"
            className={`w-100 mt-0 ${workSpaceCss.custSelect} ${workSpaceCss.mr10}`}
            classNamePrefix="select"
            styles={{
                ...customStyles,
                 control: (provided,state) => ({
                    ...provided,
                    backgroundColor: '#F4FAF5', 
                    borderColor: '#A0DABC',       
                    borderWidth: '1px',           
                    borderStyle: 'solid',         
                    borderRadius:'10px',
                    boxShadow: state.isFocused ? '0 0 0 1px #A0DABC' : 'none', 
                    '&:hover': {
                        borderColor: '#A0DABC',   
                    },
                }),
                option: (provided, state) => ({
                    ...provided,
                    backgroundColor: 'transparent',
                    padding:'0px',
                    borderColor: 'transparent',
                    cursor:'pointer',
                    '&:hover': {
                        backgroundColor: 'transparent',
                    }
                }),
                placeholder: (provided) => ({
                    ...provided,
                    color: '#809790',
                    fontSize:'14px',
                    fontWeight:'400'              
                }),   
            }}
            isClearable={true}
            isSearchable={false}
            />
          
            <button type="button" onClick={handleApplyFilters} 
                className={`${workSpaceCss.filterFillBtns} ${workSpaceCss.mr10} ${workSpaceCss.bR10}`} style={{ marginLeft: '200px' }} >Apply</button>
            
            <button type="button" className={`${workSpaceCss.savefilterBtns} ${workSpaceCss.mr10} ${workSpaceCss.bR10}`}onClick={handleSaveFilter} >Apply to all</button>
            <div  className={workSpaceCss.eyeIconWrapper}>

             <button
                    className={`${workSpaceCss.filterBtns}`}
                    onClick={() => setShowFilter(prev => !prev)} 
              >
                    <EyeIcon />
              </button>
              <span className={workSpaceCss.eyeTooltipText_unique123}>Hide Filters</span>

              </div>
            {/* --- ADD RENDERERS FOR THE TOASTERS HERE --- */}
            {showSuccessToaster && (
                <SuccessModal
                    handleClose={handleCloseSuccessToaster}
                    setSuccessModal={setShowSuccessToaster} 
                    setSuccessMessage={setSuccessMessage} 
                    successMessage={successMessage}
                    bodycls=""
                />
            )}

            {showErrorToaster && (
                <ErrorModal
                    handleClose={handleCloseErrorToaster}
                    setErrorModal={setShowErrorToaster} 
                    setErrorMessage={setErrorMessage}
                    errorMessage={errorMessage}
                />
            )}
        </div>
    )
}

const TasksLayer = ({ taskStatusSummary = {}, visibleCards = [] }) =>{

    if (!visibleCards.includes('taskStatusSummary')) return null; 

    const getRoundedPercentage = (percentageStr = "0.00%") => {
        const num = parseFloat(percentageStr.replace('%', '')) || 0;
        return `${Math.round(num)}%`;
    };

    const submitted = taskStatusSummary["submitted"] || { count: 0, percentage: "0.00%" };
    const approved = taskStatusSummary["approved"] || { count: 0, percentage: "0.00%" };
    const overdue = taskStatusSummary["over due"] || { count: 0, percentage: "0.00%" };
    const openStatuses = ["open", "returned", "re-opened", "over due"];

    const openCount = openStatuses.reduce(
        (sum, key) => sum + (taskStatusSummary[key]?.count || 0),
        0
    );

    const totalCount = Object.values(taskStatusSummary).reduce(
        (sum, val) => sum + (val.count || 0),
        0
    );

    const openPercentage = totalCount ? Math.round((openCount / totalCount) * 100) : 0;

    return (
        <div className={`${workSpaceCss.df} ${workSpaceCss.jsBtw} ${workSpaceCss.mb10}`} style={{ gap: '10px' }}>
            <DisplayCard label="OPEN TASKS" value={openCount} image={OpenTask} />
            <DisplayCard label="IN PROGRESS" value={submitted.count} image={InprogressTask} />
            <DisplayCard label="COMPLETED" value={getRoundedPercentage(approved.percentage)} image={CompletedTask} />
            <DisplayCard label="OVERDUE" value= {overdue.count} image={OverdueTask} />
        </div>
    )
}

const CardsContainer = ({ moduleProgress, overdueTasksData,visibleCards,routerHistory, w_id }) => {

    return (
        <div className={workSpaceCss.df}>
            
            {visibleCards.includes('moduleProgress') && (
                <CustmCard moduleProgress={moduleProgress} />
            )}

            {visibleCards.includes('overdueTasks') && (
                <OverdueCard overdueTasksData={overdueTasksData} routerHistory={routerHistory} w_id={w_id} />
            )}
  

        </div>
    )
}

const CustmCard = ({ moduleProgress = {} }) => {
  const [tooltip, setTooltip] = useState({
    show: false,
    text: "",
    x: 0,
    y: 0,
  });  
  const getPercentNum = (val) => parseFloat(val?.replace('%', '')) || 0;

  const statusColorMap = {
    open: "#D5DAD9",
    submitted: "#F6C858",
    approved: "#94E0AE",
    "over due": "#EB6A6A",
  
  };

  const statusOrder = ["open", "submitted", "approved", "over due"];
  
  const legendLabels = {
    open: "Assigned",
    submitted: "In progress",
    approved: "Completed",
    "over due": "Overdue",
  };

  return (
    <div
      className={`${workSpaceCss.cardW} ${workSpaceCss.mr10} ${workSpaceCss.mb10}`}
      style={{
        width: "100%",
        maxWidth: "500px",
        minWidth: "440px",
        overflow: "hidden",
        position: "relative", 
        borderRadius: "16px"
      }}
    >
      <div className={`${workSpaceCss.fw500} ${workSpaceCss.cardHeading}`} style={{ marginBottom: "10px" }}>
        Progress by module
      </div>

      {Object.keys(moduleProgress).length === 0 && (
        <div  style={{ textAlign: "center" }}>
          No data available.
        </div>
      )}

      {Object.entries(moduleProgress).sort(([a], [b]) => a.localeCompare(b)).map(([moduleName, statuses]) => {
        const combinedStatuses = { ...statuses };
        const openLikeStatuses = ["open", "re-opened", "returned"];
        let openTotal = 0;
        let openCount = 0;

        openLikeStatuses.forEach((key) => {
          const item = statuses?.[key];
          const val = getPercentNum(item?.percentage);
          const countVal = parseInt(item?.count) || 0;

          openTotal += val;
          openCount += countVal;

          delete combinedStatuses[key];
        });

        if (openTotal > 0) {
          combinedStatuses["open"] = {
            percentage: `${openTotal}%`,
            count: openCount,
          };
        }

        const orderedStatusEntries = statusOrder
          .map((status) => {
            if (combinedStatuses[status]) {
              return [status, combinedStatuses[status]];
            }
            return null;
          })
          .filter(Boolean); 

        return (
          <div
            key={moduleName}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "15px",
              width: "100%",
              padding: "0px 10px"
            }}
          >
            <div style={{ width: "120px", textTransform: "capitalize", fontSize:"14.28px", fontWeight:"400", color:"#183930"}}>
              {moduleName}
            </div>

            <div style={{ flex: 1 }}>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  height: "18px",
                  left: "50px",
                  borderRadius: "4px",
                  overflow: "hidden",
                  border: "0.88px",
                  padding: "2px",
                  gap: "1px",
                }}
              >
                {orderedStatusEntries.map(([status, data]) => {
                  const percentage = data?.percentage || "0%";
                  const percentNum = getPercentNum(percentage);

                  if (percentNum <= 0) return null;
                  const tooltipText = `${status.charAt(0).toUpperCase() + status.slice(1)}: ${percentage}${data?.count ? ` (${data.count})` : ''}`;


                  return (
                    <div
                      key={status}
                      style={{
                        width: `${percentNum}%`,
                        backgroundColor: statusColorMap[status] || "#ccc",
                        height: "100%",
                        position: "relative",
                        cursor: "pointer",
                         borderRadius: "2px", 
                          marginRight: "1px", 
                      }}
                   
                        onMouseEnter={(e) => {
                            const rect = e.target.getBoundingClientRect();
                            setTooltip({
                            show: true,
                            text: tooltipText,
                            x: rect.left + rect.width / 2,
                            y: rect.top - 8,
                            });
                        }}
                        onMouseLeave={() =>
                            setTooltip({ ...tooltip, show: false })
                        }

                    />
                  );
                })}
                
              </div>
            </div>
          </div>
        );
      })}
       
      {/* Footer with HR line and custom legends */}
      <div
        style={{
          borderTop: "1px solid #e0e0e0",
          paddingTop: "10px",
          paddingBottom: "10px",
          display: "flex",
          gap: "20px",
          justifyContent: "center",
          flexWrap: "wrap",
          marginTop:"40px"
        }}
      >
        {statusOrder.map((status) => (
          <div
            key={status}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "12px",
            }}
          >
            <div
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: statusColorMap[status],
                borderRadius: "50%",
              }}
            />
            <span>{legendLabels[status]}</span>
          </div>
        ))}
      </div>

      {/* Custom Tooltip */}
      {tooltip.show && (
        <div
        style={{
            position: "fixed",
            top: tooltip.y + 28, 
            left: tooltip.x,
            transform: "translateX(-50%)",
            backgroundColor: "#333",
            color: "#fff",
            padding: "4px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            whiteSpace: "nowrap",
            zIndex: 1000,
            pointerEvents: "none",
            }}
        >
          {tooltip.text}
        </div>
      )}
    </div>
  );
};

const OverdueCard = ({ overdueTasksData = [], routerHistory, w_id }) => {
    const getFormattedDate = (dueDate) => {
          const today = new Date();
          const tomorrow = new Date(today);
          tomorrow.setDate(today.getDate() + 1);

          const yesterday = new Date(today);
          yesterday.setDate(today.getDate() - 1);

          const taskDueDate = new Date(dueDate);

          if (taskDueDate.toDateString() === yesterday.toDateString()) {
              return <span style={{ color: '#E94D4D' }}>Yesterday</span>; 
          }

          if (taskDueDate.toDateString() === today.toDateString()) {
              return <span style={{ color: '#E94D4D' }}>Today</span>; 
          }

          if (taskDueDate.toDateString() === tomorrow.toDateString()) {
              return <span style={{ color: '#E94D4D' }}>Tomorrow</span>; 
          }

          // return taskDueDate.toLocaleDateString('en-GB'); 
          return new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
          }).format(taskDueDate);
      };


    const sortedDeadlines = [...overdueTasksData].sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate));

    return (
        <div className={workSpaceCss.cardsLayout}>
            <div className={workSpaceCss.cardHeading}>
                Overdue Tasks
            </div>
            <div className={workSpaceCss.tableContainer}>
                <table className={workSpaceCss.stickyTable}>
                    <thead>
                        <tr>
                            <th style={{width:'30%'}}>task name</th>
                            <th style={{width:'15%'}}>assignee</th>
                            <th style={{width:'15%'}}>approver</th>
                            <th style={{width:'15%'}}>module</th>
                            <th>due date</th>
                        </tr>
                    </thead>
                    <tbody>
                         {sortedDeadlines.length > 0 ? (
                            sortedDeadlines.map((task, index) => (
                                <tr key={index}
                                    style={{cursor:'pointer',borderBottom: '1px solid #EAEEED'}}
                                    onClick={()=>
                                        routerHistory.push({
                                        pathname: `/bookclosure/${w_id[2]}`,
                                        state: {
                                            overviewFilters: {
                                                companyIDs: Array.isArray(task.companyID)
                                                    ? task.companyID
                                                    : [task.companyID],
                                                taskId: task.taskID
                                            }
                                        }
                                        })

                                    }       

                                >
                                    <td style={{ textAlign: 'left' }}>
                                        <span className={workSpaceCss.singleLineEllipsis}>{task.taskName}</span>
                                    </td>
                                    <td>
                                        <span className={workSpaceCss.singleLineEllipsis}>{task.assignee.map((a) => a.name).join(', ')}</span>
                                    </td>
                                    <td>
                                        <span className={workSpaceCss.singleLineEllipsis}>{task.approver?.name || '-'}</span>
                                    </td>
                                    <td>
                                        <span className={workSpaceCss.singleLineEllipsis}>{task.module}</span>
                                    </td>
                                     <td style={{ color: '#E94D4D' }}>{getFormattedDate(task.dueDate)}</td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" style={{ textAlign: "center" }}>
                                    No overdue tasks available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

const UpcomingDeadlinesCardsContainer = ({ tasksAssignedToUserData,upcomingDeadlinesData,visibleCards,routerHistory, w_id }) => {
    return (
        <div className={workSpaceCss.df}>
           
            {visibleCards.includes('tasksAssignedToUser') && (
            <TasksAssignedToUserData tasksAssignedToUserData={tasksAssignedToUserData}/>
            )}

            {visibleCards.includes('upcomingDeadlines') && (
            <UpcomingDeadlinesData  upcomingDeadlinesData={upcomingDeadlinesData} routerHistory={routerHistory} w_id={w_id} />
            )}
            
        </div>
        
    )
}

const TasksAssignedToUserData  = ({ tasksAssignedToUserData = [], routerHistory, w_id }) => {
  
        const getFormattedDate = (dueDate) => {
          const today = new Date();
          const tomorrow = new Date(today);
          tomorrow.setDate(today.getDate() + 1);

          const yesterday = new Date(today);
          yesterday.setDate(today.getDate() - 1);

          const taskDueDate = new Date(dueDate);

          if (taskDueDate.toDateString() === yesterday.toDateString()) {
              return <span style={{ color: '#E5A503' }}>Yesterday</span>; 
          }

          if (taskDueDate.toDateString() === today.toDateString()) {
              return <span style={{ color: '#E5A503' }}>Today</span>; 
          }

          // Check if the task is tomorrow
          if (taskDueDate.toDateString() === tomorrow.toDateString()) {
              return <span style={{ color: '#E5A503' }}>Tomorrow</span>; 
          }

          // return taskDueDate.toLocaleDateString('en-GB'); 
          return new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
          }).format(taskDueDate);
      };


    const sortedDeadlines = [...tasksAssignedToUserData].sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate));

    return (
        <div
            className={`${workSpaceCss.cardW} ${workSpaceCss.mr10} ${workSpaceCss.mb10}`}
            style={{
                width: "100%",
                maxWidth: "602px",
                minWidth: "440px",
                overflow: "hidden",
                position: "relative",
                display: "flex",
                flexDirection: "column", 
            }}
            >
            <div className={`${workSpaceCss.fw500} ${workSpaceCss.cardHeading}`} style={{ marginBottom: "10px" }}>
                Assigned to me
            </div>
            <div className={workSpaceCss.tableContainer}>
                <table className={workSpaceCss.stickyTable}>
                    <thead>
                        <tr>
                            <th style={{width:'40%'}}>Task Name</th>
                            <th style={{width:'20%'}}>Assignee</th>
                            <th style={{width:'20%'}}>approver</th>
                            <th style={{width:'20%'}}>due date</th>
                        </tr>
                    </thead>
                    <tbody>
                         {sortedDeadlines.length > 0 ? (
                            sortedDeadlines.map((task, index) => (
                                <tr key={index}
                                    style={{cursor:'pointer'}}
                                    onClick={()=>
                                        routerHistory.push({
                                        pathname: `/bookclosure/${w_id[2]}`,
                                        state: {
                                            overviewFilters: {
                                                companyIDs: Array.isArray(task.companyID)
                                                    ? task.companyID
                                                    : [task.companyID],
                                                taskId: task.taskID
                                            }
                                        }
                                        })

                                    }       

                                >
                                    <td style={{ textAlign: 'left' }}>
                                        <span className={workSpaceCss.singleLineEllipsis}>{task.taskName}</span>
                                    </td>
                                    <td>
                                        <span className={workSpaceCss.singleLineEllipsis}>{task.assignee.map((a) => a.name).join(', ')}</span>
                                    </td>
                                    <td>
                                        <span className={workSpaceCss.singleLineEllipsis}>{task.approver?.name || '-'}</span>
                                    </td>
                                    
                                    <td>{getFormattedDate(task.dueDate)}</td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" style={{ textAlign: "center" }}>
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

const UpcomingDeadlinesData  = ({ upcomingDeadlinesData = [], routerHistory, w_id }) => {
        const getFormattedDate = (dueDate) => {
            const today = new Date();
            const tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);

            const taskDueDate = new Date(dueDate);

            if (taskDueDate.toDateString() === tomorrow.toDateString()) {
            return (
                <span style={{ color: '#E5A503' }}>Tomorrow</span>
            );                
            }

            // return taskDueDate.toLocaleDateString('en-GB'); 
            return new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
          }).format(taskDueDate);
        };

    const sortedDeadlines = [...upcomingDeadlinesData].sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate));

    return (
        <div
            className={`${workSpaceCss.cardW} ${workSpaceCss.mb10}`}
            style={{
                width: "100%",
                maxWidth: "602px",
                minWidth: "440px",
                overflow: "hidden",
                position: "relative",
                marginRight: "0px",
                borderRadius: "16px"

            }}
            >
            <div className={`${workSpaceCss.fw500} ${workSpaceCss.cardHeading}`} style={{ marginBottom: "10px" }}>
                Upcoming Deadlines
            </div>
            <div className={workSpaceCss.tableContainer}>
                <table className={workSpaceCss.stickyTable}>
                    <thead>
                        <tr>
                            <th style={{width:'40%'}}>Task/Template Name</th>
                            <th style={{width:'20%'}}>Assignee</th>
                            <th style={{width:'20%'}}>approver</th>
                            <th style={{width:'20%'}}>due date</th>
                        </tr>
                    </thead>
                    <tbody>
                         {sortedDeadlines.length > 0 ? (
                            sortedDeadlines.map((task, index) => (
                                <tr key={index}
                                    style={{cursor:'pointer'}}
                                    onClick={()=>
                                        routerHistory.push({
                                        pathname: `/bookclosure/${w_id[2]}`,
                                        state: {
                                            overviewFilters: {
                                                companyIDs: Array.isArray(task.companyID)
                                                    ? task.companyID
                                                    : [task.companyID],
                                                taskId: task.taskID
                                            }
                                        }
                                        })

                                    }       

                                >
                                    <td style={{ textAlign: 'left' }}>
                                        <span className={workSpaceCss.singleLineEllipsis}>{task.taskName}</span>
                                    </td>
                                    <td>
                                        <span className={workSpaceCss.singleLineEllipsis}>{task.assignee.map((a) => a.name).join(', ')}</span>
                                    </td>
                                    <td>
                                        <span className={workSpaceCss.singleLineEllipsis}>{task.approver?.name || '-'}</span>
                                    </td>
                                    
                                    <td>{getFormattedDate(task.dueDate)}</td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" style={{ textAlign: "center" }}>
                                    No upcoming deadlines available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}


const CommentsCard = ({ commentsData = {} }) => {
  const totalComments = commentsData?.totalComments || 0;
  const resolved = commentsData?.statusCounts?.closed || 0;
  const unresolved = commentsData?.statusCounts?.unresolved || 0;
  const overdue = commentsData?.statusCounts?.overdue || 0;

  // If no comments, don’t render the card
  if (totalComments === 0) {
    return null;
  }
  const chartColors = [
         '#A8E6A1', '#7EB1FC', '#FFD166'
        ];
  const data = {
    labelstool: ['Resolved', 'Unresolved', 'Overdue'],
  
    datasets: [
      {
        data: [resolved, unresolved, overdue],
        backgroundColor: chartColors,
        hoverBackgroundColor:chartColors,
        borderColor: "#fff",
        hoverBorderColor: "#fff",           
        borderWidth: 3,      
        hoverOffset: 6,
        borderRadius: 10, 

      },
    ],
  };

  const options = {
  responsive: true,
  maintainAspectRatio: false,  
  cutout: '40%',
  radius: "100%",  
  plugins: {
  legend: { display: false }, 
  tooltip: { 
  backgroundColor: '#111',
  titleColor: '#fff',
  bodyColor: '#fff',
  displayColors: true,   
  boxPadding: 4,
  padding: 10,
  cornerRadius: 6,
  caretSize: 6,
  position: 'nearest',   
  caretPadding: 1000,     
  callbacks: {
    label: (context) => {
      const index = context.dataIndex;
      const customLabel = context.chart.data.labelstool[index];
      return ` ${customLabel}`;
    },
    afterLabel: (context) => {
      return `${context.raw} Comments`;
    }
  }
  
}


  },
};


  // Plugin for center text
  const centerTextPlugin = {
    id: 'centerTextPlugin',
    afterDraw: (chart) => {
      const { ctx, width, height } = chart;
      ctx.save();
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      // Big number
      ctx.font = 'bold 32px sans-serif';
      ctx.fillStyle = '#33584E';
      ctx.fillText(totalComments, width / 2, height / 2 - 10);

      // Label below
      ctx.font = '14px sans-serif';
      ctx.fillStyle = '#809790';
      ctx.fillText('Total Comments', width / 2, height / 2 + 15);

      ctx.restore();
    },
  };
  const statusOrder = ['resolved', 'unresolved', 'overdue'];
  const statusColorMap = {
    resolved: '#A8E6A1',
    unresolved: '#7EB1FC',
    overdue: '#FFD166',
  };
  const legendLabels = {
    resolved: 'Resolved Comments',
    unresolved: 'Unresolved Comments',
    overdue: 'Overdue Comments',
  };
  return (
    <div
      className={`${workSpaceCss.cardW} ${workSpaceCss.mb10}`}
      style={{
        width: '100%',
        maxWidth: '602px',
        minWidth: '440px',
        overflow: 'hidden',
        position: 'relative',
        marginRight: '0px',
        borderRadius: "16px"


      }}
    >
      <div
        className={`${workSpaceCss.fw500} ${workSpaceCss.cardHeading}`}
        style={{ marginBottom: '10px' }}
      >
        Comment Metrics
      </div>
      <div style={{ height: '300px', width: '100%' }}>
      <Doughnut data={data} options={options} plugins={[centerTextPlugin]} />
    </div>
    
      {/* Footer with HR line and custom legends */}
      <div
        style={{
          borderTop: '1px solid #e0e0e0',
          paddingTop: '10px',
          paddingBottom: '10px',
          display: 'flex',
          gap: '20px',
          justifyContent: 'center',
          flexWrap: 'wrap',
          marginTop:"40px"
        }}
      >
        {statusOrder.map((status) => (
          <div
            key={status}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '12px',
            }}
          >
            <div
              style={{
                width: '12px',
                height: '12px',
                backgroundColor: statusColorMap[status],
                borderRadius: '50%',
              }}
            />
            <span>{legendLabels[status]}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const AssigneeContainer = ({ assigneeProgressData ,visibleCards}) => {

    return (
        <div className={workSpaceCss.df}>
           
            
             {visibleCards.includes('teamActivityTracker') && (
            <TeamActivityCard assigneeProgressData={assigneeProgressData} />
            )}

            {visibleCards.includes('assigneeProgress') && (
            <AssigneeProgressData  assigneeProgressData={assigneeProgressData}  />
            )}

        </div>
        
    )
}

const TeamActivityCard = ({ assigneeProgressData = {} }) => {
  const [tooltip, setTooltip] = useState({
    show: false,
    text: "",
    x: 0,
    y: 0,
  });

  const statusColorMap = {
    open: "#D5DAD9",
    submitted: "#F6C858",
    approved: "#94E0AE",
    "over due": "#EB6A6A",
  };

  const statusOrder = ["open", "submitted", "approved", "over due"];

  // Custom legend names
  const legendLabels = {
    open: "Assigned",
    submitted: "In progress",
    approved: "Completed",
    "over due": "Overdue",
  };

  const transformProgressData = (rawData) => {
    const result = {};
    Object.values(rawData || {}).forEach((data) => {
      const total = Number(data?.total ?? data?.assigned ?? 0);
      const safeTotal = total > 0 ? total : 1;
      const transformed = {};

      statusOrder.forEach((key) => {
        const count = Number(data?.[key] ?? 0);
        const percentage = ((count / safeTotal) * 100).toFixed(2) + "%";
        transformed[key] = { percentage, count };
      });

      const label = data?.name || "Unknown";
      result[label] = transformed;
    });
    return result;
  };

  const formattedData = transformProgressData(assigneeProgressData);

  return (
    <div
      className={`${workSpaceCss.cardW} ${workSpaceCss.mr10} ${workSpaceCss.mb10}`}
      style={{
        width: "100%",
        maxWidth: "602px",
        minWidth: "440px",
        overflow: "hidden",
        position: "relative",
        display: "flex",
        flexDirection: "column", 
        borderRadius: "16px"

      }}
    >
      <div
        className={`${workSpaceCss.fw500} ${workSpaceCss.cardHeading}`}
        style={{ marginBottom: "10px" }}
      >
        Team Activity Tracker
      </div>

      {/* Main content */}
      <div style={{ flex: 1, paddingBottom: "10px" }}>
        {Object.keys(formattedData).length === 0 && (
          <div style={{ textAlign: "center" }}>No data available.</div>
        )}

        {Object.entries(formattedData)
          .sort(([a], [b]) => a.localeCompare(b))
          .map(([moduleName, statuses]) => {
            const orderedStatusEntries = statusOrder
              .map((status) => [status, statuses[status]])
              .filter(([_, data]) => data?.count > 0);

            const totalNonZeroCount = orderedStatusEntries.reduce(
              (sum, [_, data]) => sum + data.count,
              0
            );

            return (
              <div
                key={moduleName}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "15px",
                  width: "100%",
                  padding: "0px 20px",
                }}
              >
               <div style={{ width: "120px", textTransform: "capitalize", fontSize:"14.28px", fontWeight:"400", color:"#183930",
                 display: "flex",justifyContent: "flex-end",alignItems: "center",gap: "8px"}}>
                  {moduleName}
                  <img 
                    src={Profile} 
                    alt="Profile" 
                    style={{ width: "25px", height: "25px", borderRadius: "50%",marginRight:"8px" }} 
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      height: "18px",
                      borderRadius: "4px",
                      overflow: "hidden",
                      padding: "2px",
                      gap: "1px",
                    }}
                  >
                    {orderedStatusEntries.map(([status, data]) => {
                      const widthPercent = (
                        (data.count / totalNonZeroCount) *
                        100
                      ).toFixed(2);
                      const tooltipText = `${status.charAt(0).toUpperCase() +
                        status.slice(1)}: ${widthPercent}% (${data.count})`;

                      return (
                        <div
                          key={status}
                          style={{
                            width: `${widthPercent}%`,
                            backgroundColor: statusColorMap[status] || "#ccc",
                            height: "100%",
                            position: "relative",
                            cursor: "pointer",
                            borderRadius: "2px", 
                            marginRight: "1px", 
                          }}
                          onMouseEnter={(e) => {
                            const rect = e.target.getBoundingClientRect();
                            setTooltip({
                              show: true,
                              text: tooltipText,
                              x: rect.left + rect.width / 2,
                              y: rect.top - 8,
                            });
                          }}
                          onMouseLeave={() =>
                            setTooltip((t) => ({ ...t, show: false }))
                          }
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
        
      {/* Footer with HR line and custom legends */}
      <div
        style={{
          borderTop: "1px solid #e0e0e0",
          paddingTop: "10px",
          paddingBottom: "10px",
          display: "flex",
          gap: "20px",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        {statusOrder.map((status) => (
          <div
            key={status}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "12px",
            }}
          >
            <div
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: statusColorMap[status],
                borderRadius: "50%",
              }}
            />
            <span>{legendLabels[status]}</span>
          </div>
        ))}
      </div>

      {/* Tooltip */}
      {tooltip.show && (
        <div
          style={{
            position: "fixed",
            top: tooltip.y + 28,
            left: tooltip.x,
            transform: "translateX(-50%)",
            backgroundColor: "#333",
            color: "#fff",
            padding: "4px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            whiteSpace: "nowrap",
            zIndex: 1000,
            pointerEvents: "none",
          }}
        >
          {tooltip.text}
        </div>
      )}
    </div>
  );
};

const AssigneeProgressData = ({ assigneeProgressData = {} }) => {
  const labels = Object.values(assigneeProgressData).map((assignee) => assignee.name);
  const data = Object.values(assigneeProgressData).map((assignee) => assignee.total);
  const chartColors = [
          "#94E0AE",
          "#639FF0",
          "#F6C858",
          "#61CBDB",
          "#E5A1E4",
        ];
  const doughnutChartData = {
    labels,
    datasets: [
      {
        data,
        backgroundColor: chartColors,
        hoverBackgroundColor:chartColors,
        borderColor: "#fff",
        hoverBorderColor: "#fff",           
        borderWidth: 3,      
        hoverOffset: 6,
        borderRadius: 10, 

      },
    ],
  };

  const doughnutChartOptions = {
    responsive: true,
    cutout: 0,  
    radius: "95%",  
    spacing: 0,
    plugins: {
      legend: {
        display: true,
        position: "right",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
        },
      },
      tooltip: {
        enabled: false, 
      },
    },
  };

  const drawPercentPlugin = {
    id: "drawPercentPlugin",
    afterDraw: (chart) => {
      const { ctx, data } = chart;
      const dataset = data.datasets[0];
      const total = dataset.data.reduce((a, b) => a + b, 0);

      chart.getDatasetMeta(0).data.forEach((arc, index) => {
        const value = dataset.data[index];
        if (!value) return;
        const percentage = ((value / total) * 100).toFixed(0) + "%";
        const { x, y } = arc.tooltipPosition();

        ctx.save();
        ctx.fillStyle = "#fff";
        ctx.font = "bold 13px sans-serif";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(percentage, x, y);
        ctx.restore();
      });
    },
  };

  return (
    <div
      className={`${workSpaceCss.cardW} ${workSpaceCss.mb10}`}
      style={{
        width: "100%",
        maxWidth: "602px",
        minWidth: "440px",
        overflow: "hidden",
        position: "relative",
        marginRight: "0px",
        borderRadius: "16px"

      }}
    >
      <div
        className={`${workSpaceCss.fw500} ${workSpaceCss.cardHeading}`}
        style={{ marginBottom: "10px" }}
      >
        Total Tasks by Assignee
      </div>

      <div style={{ height: "300px" }}>  
        <Doughnut
            data={doughnutChartData}
            options={{ ...doughnutChartOptions, maintainAspectRatio: false }}
            plugins={[drawPercentPlugin]}
        />
       </div>

    </div>
  );
};

const PendingDataContainer = ({ approvalPendingData,commentsData,visibleCards, routerHistory, w_id }) => {

    return (
        <div className={workSpaceCss.df}>


            {visibleCards.includes('approvalPending') && (
            <ApprovalPendingCard  approvalPendingData={approvalPendingData} routerHistory={routerHistory} w_id={w_id} />
            )}

            {visibleCards.includes('commentStatistics') && (
                <CommentsCard commentsData={commentsData}/>
            )}

        </div>
        
    )
}



const ApprovalPendingCard  = ({ approvalPendingData = [], routerHistory, w_id }) => {
        const getFormattedDate = (dueDate) => {
            const today = new Date();
            const tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);

            const taskDueDate = new Date(dueDate);

            if (
                taskDueDate.toDateString() === today.toDateString() ||
                taskDueDate.toDateString() === tomorrow.toDateString()
            ) {
                return <span style={{ color: '#E5A503' }}>
                    {taskDueDate.toDateString() === today.toDateString() ? 'Today' : 'Tomorrow'}
                </span>; 
            }

            // return taskDueDate.toLocaleDateString('en-GB'); 
            return new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
          }).format(taskDueDate);
        };


    const sortedDeadlines = [...approvalPendingData].sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate));

        return (
            // <div className={workSpaceCss.cardsLayout}>
            <div
            className={`${workSpaceCss.cardW} ${workSpaceCss.mr10} ${workSpaceCss.mb10}`}
            style={{
                width: "100%",
                maxWidth: "584px",
                minWidth: "440px",
                overflow: "hidden",
                position: "relative",
                display: "flex",
                flexDirection: "column", 
                borderRadius: "16px"

            }}
            >
                <div className={workSpaceCss.cardHeading}>
                    Pending Approvals
                </div>
                <div className={workSpaceCss.tableContainer}>
                    <table className={workSpaceCss.stickyTable}>
                        <thead>
                            <tr>
                                <th style={{width:'40%'}}>task name</th>
                                <th style={{width:'20%'}}>assignee</th>
                                <th style={{width:'20%'}}>approver</th>
                                <th style={{width:'20%'}}>due date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sortedDeadlines.length > 0 ? (
                                sortedDeadlines.map((task, index) => (
                                    <tr key={index}
                                        style={{cursor:'pointer'}}
                                        onClick={()=>
                                            routerHistory.push({
                                            pathname: `/bookclosure/${w_id[2]}`,
                                            state: {
                                                overviewFilters: {
                                                    companyIDs: Array.isArray(task.companyID)
                                                        ? task.companyID
                                                        : [task.companyID],
                                                    taskId: task.taskID
                                                }
                                            }
                                            })

                                        }       

                                    >
                                        <td style={{ textAlign: 'left' }}>
                                            <span className={workSpaceCss.singleLineEllipsis}>{task.taskName}</span>
                                        </td>
                                        <td>
                                            <span className={workSpaceCss.singleLineEllipsis}>{task.assignee.map((a) => a.name).join(', ')}</span>
                                        </td>
                                        <td>
                                            <span className={workSpaceCss.singleLineEllipsis}>{task.approver?.name || '-'}</span>
                                        </td>
                                        
                                        <td>{getFormattedDate(task.dueDate)}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: "center" }}>
                                        No pending Approvals available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }




// const StatusByCompany = ({ moduleCompanySummary, moduleCompanyList,visibleCards = [] , w_id, routerHistory,currentFilters}) => {

//     const statusOptions = [
//         { label: 'Open', value: ['open', 'returned', 're-opened', 'over due'] },
//         { value: ['submitted'], label: 'In Progress' },
//         { value: ['approved'], label: 'Completed' },
//         { value: ['over due'], label: 'Over Due' },
//     ];

//     const [selectedStatus, setSelectedStatus] = useState(statusOptions[0]);
//     const [viewMode, setViewMode] = useState("numbers");
//     if (!visibleCards.includes('moduleCompanySummary')) return null; 

//     const SingleValue = ({ data }) => (
//         <div className={`${workSpaceCss.custSelectedLabelStatus}`}>Showing {data.label} tasks</div>
//     );

//     const modules = Object.keys(moduleCompanySummary || {});

//     const handleViewToggle = (mode) => {
//         setViewMode(mode);
//     };

//     const toArray = (val) => Array.isArray(val) ? val : [val];

//     const userIDs = Array.isArray(currentFilters.userID) ? currentFilters.userID : [];
//     const roles = Array.isArray(currentFilters.role) ? currentFilters.role : [];

//     let roleFilter = {};

//     if (userIDs.length) {
//         if (roles.length === 0) {
//         // No specific roles: assign to both
//         roleFilter = {
//             assigneeIDs: userIDs,
//             approverIDs: userIDs,
//         };
//         } else {
//         if (roles.includes("assignee")) {
//             roleFilter.assigneeIDs = userIDs;
//         }
//         if (roles.includes("approver")) {
//             roleFilter.approverIDs = userIDs;
//         }
//         }
//     }

//     console.log("roleFilter",roleFilter);

//     return (
//         <div className={`${workSpaceCss.cardsLayout} ${workSpaceCss.mt10} ${workSpaceCss.p10}`}>
//             <div className={`${workSpaceCss.statusByCompanyHeader}`}>
//                 <span className={`${workSpaceCss.statusByCompanyLabel}`}>
//                     Book Closure status by company
//                 </span>
//                 <span className={`${workSpaceCss.numberPerctangeSection}`}>
//                     <div>
//                         <span
//                             onClick={() => handleViewToggle("numbers")}
//                             className={viewMode === "numbers" ? workSpaceCss.activeRadioBtn : workSpaceCss.inactiveRadioBtn}
//                             style={{ marginRight: '30px', cursor: 'pointer' }}
//                         >
//                             {viewMode === "numbers" ? <ActiveRadioBtn style={{ marginBottom: '2px' }} /> : <InactiveRadioBtn style={{ marginBottom: '2px' }} />} Numbers
//                         </span>
//                         <span
//                             onClick={() => handleViewToggle("percentage")}
//                             className={viewMode === "percentage" ? workSpaceCss.activeRadioBtn : workSpaceCss.inactiveRadioBtn}
//                             style={{ cursor: 'pointer' }}
//                         >
//                             {viewMode === "percentage" ? <ActiveRadioBtn style={{ marginBottom: '2px' }} /> : <InactiveRadioBtn style={{ marginBottom: '2px' }} />} Percentage
//                         </span>
//                     </div>
//                 </span>
//                 <span>

//                     <Select
//                         components={{ IndicatorSeparator: () => null, SingleValue }}
//                         placeholder="Select status"
//                         name="status"
//                         className={`w-100 mt-0  ${workSpaceCss.mr10}`}
//                         classNamePrefix="select"
//                         styles={{
//                             ...customStyles,
//                             control: (provided, state) => ({
//                                 ...customStyles.control(provided, state),
//                                 borderWidth: '1px',
//                                 borderColor: '#7ECEA7',
//                                 minWidth: '265px',
//                                 '&:hover': {
//                                     borderColor: '#7ECEA7',
//                                 },
//                             }),
//                         }}
//                         isClearable={false}
//                         isSearchable={false}
//                         options={statusOptions}
//                         value={selectedStatus}
//                         onChange={setSelectedStatus}
//                     />
//                 </span>
//             </div>

//             <div className={`${workSpaceCss.statusTableWrapper}`}>
//                 <table className={workSpaceCss.statusTable}>
//                     <thead>
//                         <tr>
//                             <th style={{ textAlign: 'left' }}>Modules</th>
//                             {moduleCompanyList.map(company => (
//                                 <th key={company._id}>{company.company_name}</th>
//                             ))}
//                         </tr>
//                     </thead>

//                     <tbody>
//                         {Object.keys(moduleCompanySummary).length === 0 ? (
//                             <tr>
//                                 <td colSpan={moduleCompanyList.length + 1} style={{ textAlign: 'center', padding: '1rem' }}>
//                                     No data available
//                                 </td>
//                             </tr>
//                         ) : (
//                             Object.entries(moduleCompanySummary)
//                                 .sort(([a], [b]) => a.localeCompare(b))
//                                 .map(([moduleName, companies]) => {

//                                 const isCompletedView = selectedStatus.label === 'Completed';

//                                 // Step 1: Prepare count and percentage for each company in this module row
//                                 const rowData = moduleCompanyList.map((company) => {
//                                     const companyData = companies.find(c => c.companyID === company._id);
//                                     const total = companyData?.totalTasks || 0;

//                                     let count = 0;
//                                     let percentage = 0;

//                                     selectedStatus.value.forEach(status => {
//                                         const breakdown = companyData?.statusBreakdown?.[status];
//                                         count += breakdown?.count || 0;
//                                         percentage += parseFloat(breakdown?.percentage?.replace('%', '') || '0');
//                                     });

//                                     return {
//                                         companyID: company._id,
//                                         count,
//                                         total,
//                                         percentage: Math.round(percentage), // rounded for display and color comparison
//                                     };
//                                 });

//                                 //Finding min and max percentage of the row
//                                 const percentages = rowData.map(r => r.percentage);
//                                 const maxPercentage = Math.max(...percentages);
//                                 const minPercentage = Math.min(...percentages);

//                                 return (
//                                     <tr key={moduleName}>
//                                         <td style={{ textAlign: 'left' }}>{moduleName}</td>
//                                         {rowData.map(({ companyID, count, total, percentage }) => {
//                                             let cellColor = '';

//                                             if (total === 0) {
//                                                 cellColor = '#111111'; // black
//                                             } else {
//                                                 if (isCompletedView) {
//                                                     if (percentage === maxPercentage) cellColor = '#29A073'; // green
//                                                     else if (percentage === minPercentage) cellColor = '#F54E45'; // red
//                                                 } else {
//                                                     if (percentage === minPercentage) cellColor = '#29A073'; // green
//                                                     else if (percentage === maxPercentage) cellColor = '#F54E45'; // red
//                                                 }
//                                             }


//                                             const displayValue =
//                                                 viewMode === 'percentage' ? `${percentage}%` : `${count}/${total}`;

//                                             return (
//                                                 <td
//                                                     key={companyID}
//                                                     style={{ color: cellColor }}
//                                                     className={workSpaceCss.statusTdText}
                                                    
//                                                 >
//                                                     <span className={workSpaceCss.navigationStyle}
//                                                         onClick={() => {
//                                                             routerHistory.push({
//                                                                 pathname: `/bookclosure/${w_id[2]}`,
//                                                                 state: {
//                                                                     overviewFilters: {
//                                                                         modules: toArray(moduleName),
//                                                                         companyIDs: toArray(companyID),
//                                                                         status: toArray(selectedStatus.value),
//                                                                         ...roleFilter,
//                                                                     }
//                                                                 }
//                                                             });
//                                                         }}
//                                                     >
//                                                         {displayValue}  
//                                                     </span>
//                                                 </td>
//                                             );
//                                         })}
//                                     </tr>
//                                 );
//                             })
//                         )}
//                     </tbody>
//                 </table>
//             </div>
//         </div>
//     );
// };   



const StatusByCompany = ({ moduleCompanySummary, moduleCompanyList, visibleCards = [], w_id, routerHistory, currentFilters }) => {

    const statusOptions = [
        { label: 'Open', value: ['open', 'returned', 're-opened', 'over due'] },
        { value: ['submitted'], label: 'In Progress' },
        { value: ['approved'], label: 'Completed' },
        { value: ['over due'], label: 'Over Due' },
    ];

    const [selectedStatus, setSelectedStatus] = useState(statusOptions[0]);
    const [viewMode, setViewMode] = useState("numbers");

    if (!visibleCards.includes('moduleCompanySummary')) return null;

    const SingleValue = ({ data }) => (
        <div className={`${workSpaceCss.custSelectedLabelStatus}`}>Showing {data.label} tasks</div>
    );

    // Sort modules alphabetically
    const modules = Object.keys(moduleCompanySummary || {}).sort((a, b) => a.localeCompare(b));

    const handleViewToggle = (mode) => {
        setViewMode(mode);
    };

    const toArray = (val) => Array.isArray(val) ? val : [val];

    const userIDs = Array.isArray(currentFilters.userID) ? currentFilters.userID : [];
    const roles = Array.isArray(currentFilters.role) ? currentFilters.role : [];

    let roleFilter = {};

    if (userIDs.length) {
        if (roles.length === 0) {
            roleFilter = { assigneeIDs: userIDs, approverIDs: userIDs };
        } else {
            if (roles.includes("assignee")) roleFilter.assigneeIDs = userIDs;
            if (roles.includes("approver")) roleFilter.approverIDs = userIDs;
        }
    }


    return (
        <div className={`${workSpaceCss.cardsLayout} ${workSpaceCss.mt10} ${workSpaceCss.p10}`}>
            <div className={`${workSpaceCss.statusByCompanyHeader}`}>
                <span className={`${workSpaceCss.statusByCompanyLabel}`}>
                    Book Closure status by module
                </span>
                <span className={`${workSpaceCss.numberPerctangeSection}`}>
                    <div>
                        <span
                            onClick={() => handleViewToggle("numbers")}
                            className={viewMode === "numbers" ? workSpaceCss.activeRadioBtn : workSpaceCss.inactiveRadioBtn}
                            style={{ marginRight: '30px', cursor: 'pointer' }}
                        >
                            {viewMode === "numbers" ? <ActiveRadioBtn style={{ marginBottom: '2px' }} /> : <InactiveRadioBtn style={{ marginBottom: '2px' }} />} Numbers
                        </span>
                        <span
                            onClick={() => handleViewToggle("percentage")}
                            className={viewMode === "percentage" ? workSpaceCss.activeRadioBtn : workSpaceCss.inactiveRadioBtn}
                            style={{ cursor: 'pointer' }}
                        >
                            {viewMode === "percentage" ? <ActiveRadioBtn style={{ marginBottom: '2px' }} /> : <InactiveRadioBtn style={{ marginBottom: '2px' }} />} Percentage
                        </span>
                    </div>
                </span>
                <span>
                    <Select
                        components={{ IndicatorSeparator: () => null, SingleValue }}
                        placeholder="Select status"
                        name="status"
                        className={`w-100 mt-0  ${workSpaceCss.mr10}`}
                        classNamePrefix="select"
                        styles={{
                            ...customStyles,
                            control: (provided, state) => ({
                                ...customStyles.control(provided, state),
                                borderWidth: '1px',
                                borderColor: '#7ECEA7',
                                // minWidth: '265px',
                                '&:hover': { borderColor: '#7ECEA7' },
                            }),
                        }}
                        isClearable={false}
                        isSearchable={false}
                        options={statusOptions}
                        value={selectedStatus}
                        onChange={setSelectedStatus}
                    />
                </span>
            </div>

            <div className={`${workSpaceCss.statusTableWrapper}`}>
                <table className={workSpaceCss.statusTable}>
                    <thead>
                        <tr style={{borderBottom: '1px solid #EAEEED' }}>
                            <th style={{ textAlign: 'left' }}>Company</th>
                            {modules.map(moduleName => (
                                <th key={moduleName}>{moduleName}</th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {moduleCompanyList.length === 0 ? (
                            <tr>
                                <td colSpan={modules.length + 1} style={{ textAlign: 'center', padding: '1rem' ,borderBottom: '1px solid #EAEEED'}}>
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            moduleCompanyList.map(company => {
                                // Prepare row data for coloring
                                const rowData = modules.map(moduleName => {
                                    const companies = moduleCompanySummary[moduleName] || [];
                                    const companyData = companies.find(c => c.companyID === company._id) || {};
                                    let count = 0, percentage = 0;

                                    selectedStatus.value.forEach(status => {
                                        const breakdown = companyData.statusBreakdown?.[status];
                                        count += breakdown?.count || 0;
                                        percentage += parseFloat(breakdown?.percentage?.replace('%', '') || '0');
                                    });

                                    return {
                                        moduleName,
                                        count,
                                        total: companyData.totalTasks || 0,
                                        percentage: Math.round(percentage),
                                    };
                                });

                                const percentages = rowData.map(r => r.percentage);
                                const maxPercentage = Math.max(...percentages);
                                const minPercentage = Math.min(...percentages);
                                const isCompletedView = selectedStatus.label === 'Completed';

                                return (
                                    <tr key={company._id}>
                                        <td style={{ textAlign: 'left' ,borderBottom: '1px solid #EAEEED'}}>{company.company_name}</td>
                                        {rowData.map(({ moduleName, count, total, percentage }) => {

                                        let bgColor = '';
                                        let bottomBorderColor = '';

                                        if (percentage >= 80) {
                                            bgColor = '#EFF7F0';
                                            bottomBorderColor = '#3AB67D'; 
                                        } else if (percentage >= 50) {
                                            bgColor = '#FFF6E3';
                                            bottomBorderColor = '#E5A503'; 

                                        } else {
                                            bgColor = '#FFE2E2';
                                            bottomBorderColor = '#E96262'; 

                                        }

                                        const displayValue = viewMode === 'percentage' ? `${percentage}%` : `${count}/${total}`;

                                        return (
                                            <td
                                                key={moduleName}
                                                style={{
                                                    backgroundColor: bgColor,
                                                    borderTop: 'none',
                                                    borderLeft: 'none',
                                                    borderRight: 'none',
                                                    borderBottom: `1px solid ${bottomBorderColor}`,
                                                }}
                                                className={workSpaceCss.statusTdText}
                                            >
                                                <span className={workSpaceCss.navigationStyle}
                                                    onClick={() => {
                                                        routerHistory.push({
                                                            pathname: `/bookclosure/${w_id[2]}`,
                                                            state: {
                                                                overviewFilters: {
                                                                    modules: toArray(moduleName),
                                                                    companyIDs: toArray(company._id),
                                                                    status: toArray(selectedStatus.value),
                                                                    ...roleFilter,
                                                                }
                                                            }
                                                        });
                                                    }}
                                                >
                                                    {displayValue}
                                                </span>
                                            </td>
                                        );
                                    })}

                                    </tr>
                                );
                            })
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};



export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: 'transparent',
    borderColor: '#7ECEA7',
    color: '#1A4338',
    boxShadow: state.isFocused ? '0 0 0 1px #7ECEA7' : 'none',
    borderWidth: '1px',
    borderRadius: '10px',
    '&:hover': {
      borderColor: '#b3c0bd',
    },
    minHeight: '38px',
    height: '38px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
    paddingTop: '1px',
  }),
  input: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#1A4338',
    fontSize: '14px',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#1A4338',
    fontSize: '14px',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e0f5e9',
    borderRadius: '0.25rem',
    border: '1px solid #c2e6d1',
    width: 'fit-content',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#4d6d64',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      backgroundColor: '#c2e6d1',
      color: '#4f665f',
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#205a46', 
    ':hover': {
        color: '#205a46',
    },
    }),
  clearIndicator: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      color: '#4f665f',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#ffffff',
    border: '1px solid #c2e6d1',
    borderRadius: '10px',
    boxShadow: '0 0 0 1px #c2e6d1',
    marginTop: '6px',
    zIndex: 10,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '4px',
    borderRadius: '10px',
  }),

option: (provided, state) => ({
  ...provided,
  backgroundColor: state.isFocused
    ? '#f4faf5'
    : 'transparent',
  color: '#4f665f',
  padding: '10px 12px',
  cursor: 'pointer',
  fontSize: '14px',
  borderRadius: '8px',
}),

  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    padding: '8px 12px',
  }),
};
